<script>
import { mapActions } from 'vuex';
import mixin from '@/plans/mx/shopping-cart';
import { isZoomSchedulerAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { isAllowSchedulerFreeTrial } from './common/freetrial';
import { planTypes } from '@/common/constants';
import { plansof } from '@/utils/chain';
import { flowTypes } from '@/common/service/page-config';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  mixins: [mixin],
  name: 'SchedulerCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  watch: {
    isAllowSchedulerFreeTrial: {
      immediate: true,
      handler(val) {
        if (
          !val &&
          (this.$context.flow === flowTypes.buyNow || this.$context.flow === flowTypes.basic2pro) &&
          plansof(this.getSelectedPlans).type(planTypes.ZOOM_SCHEDULER).freeTrial().has() &&
          plansof(this.getSelectedPlans).not().freeTrial().has() // If only have scheduler ft, don't remove
        ) {
          this.$message({
            type: 'info',
            duration: 10000,
            message: this.$t('billing.common.auto_remove_notification', [this.$t('billing.trial.title', [this.$t('billing.scheduler.title')])]),
            showClose: true
          })
          this.removePlanByKey(planTypes[planTypes.ZOOM_SCHEDULER])
        }
      }
    }
  },
  computed: {
    isAllowSchedulerFreeTrial() {
      return isAllowSchedulerFreeTrial()
    },

    showRemove() {
      // Hack: plan remove logic places in mx_remove when the user is from shopping bag
      if(isFromShoppingCart()) {
        return true;
      }
      return (!this.mx_isLastBasePlan || isZoomSchedulerAsAddonCard());
    },
  },
  methods: {
    ...mapActions(['removePlanByKey']),
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            {
              /* FREE TRIAL - Specific UI for free trial */
            }
            if (!!plan.isOnlineFreeTrial && !!plan.trialDays) {
              return (
                <div>
                  {this.mx_freeTrialTitle(this.$t('billing.scheduler.title'))}
                  {this.mx_license(plan.cartInfo.selected_number)}
                  {this.mx_freeTrialDesc(plan.trialDays)}
                  {this.mx_discount(plan.plan_code)}
                  {this.mx_cycle(plan.billing_cycle)}
                  {this.mx_edit(plan)}
                  {this.showRemove && this.mx_remove(plan)}
                </div>
              );
            }
            return (
              <div>
                {this.mx_title(
                  this.$t('billing.scheduler.title'),
                  <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>,
                )}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_license(plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                {this.showRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
    $renderTip() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
